import produce from "immer";
import { createSlice,  } from "@reduxjs/toolkit";

const initState = {
  languages: [],
  isLanguageDetected: false,
  languageDetectedId: 0,
  isLoading: true,
};

export const languageSlice = createSlice({
  name: "laguages",
  initialState: initState,
  reducers: {
    resetDetectedLanguage: (state, action) => {
      state.isLanguageDetected = false;
    },
    fetchLanguagesSuccess: (state, action) => {
      state.languages = action.payload;
      state.isLoading = false;
    },
    isLoading: (state) => {
      state.isLoading = true;
    },
    detectLanguageSuccess: (state, action) => {
      state.languageDetectedId = action.payload.langId;
      state.isLanguageDetected = true;
    },
  },
});

export const { resetDetectedLanguage, fetchLanguagesSuccess, isLoading, detectLanguageSuccess } = languageSlice.actions;

// export const languagesReducer = (state = initState, action) => {
//   switch (action.type) {
//     case "LANGUAGES/RESET_DETECTED_LANGUAGE":
//       return produce(state, (draft) => {
//         draft.isLanguageDetected = false;
//       });
//     case "LANGUAGES/GET_LANGUAGES_LIST":
//       return produce(state, (draft) => {
//         draft.languages = action.payload.languages;
//         draft.isLoading = false;
//       });
//     case "LANGUAGES/IS_LOADING":
//       return produce(state, (draft) => {
//         return (draft.isLoading = true);
//       });
//     case "LANGUAGES/DETECT_SOURCE_LANGUAGE":
//       return produce(state, (draft) => {
//         draft.languageDetectedId = action.payload.languageDetectedId;
//         draft.isLanguageDetected = action.payload.isLanguageDetected;
//       });
//     default:
//       return state;
//   }
// };
